/**
 * Unsent comment words, by thread, for as long as the same person uses this
 * tab.
 *
 * A composer that closes with its sheet (the deck's comments, a phone's line
 * thread) gives the words back when it opens again, instead of losing them to
 * one Esc. Only a new message is kept: an edit's text is already on the
 * server, and a reply's would come back without the message it answers.
 *
 * The words belong to whoever typed them. Signing out and an admin's view-as
 * swap the person without reloading the page, so both let every kept draft
 * go (`clearCommentDrafts`, beside the presentation editor's own
 * `clearKeptDrafts`) - otherwise the next person would find somebody else's
 * words in the box, ready to send under their own name.
 *
 * Memory only, on purpose: a comment is short, and nothing here should
 * outlive the tab.
 */
const drafts = new Map<string, string>();

export function readCommentDraft(key: string): string {
  return drafts.get(key) ?? "";
}

export function keepCommentDraft(key: string, words: string): void {
  if (words.trim()) drafts.set(key, words);
  else drafts.delete(key);
}

export function dropCommentDraft(key: string): void {
  drafts.delete(key);
}

/** A different person from now on: none of these words are theirs. */
export function clearCommentDrafts(): void {
  drafts.clear();
}
